import ImSideMenu from '@/components/common/sideMenu/ImSideMenu.vue'
import MIM_CL_001 from '@/views/im/MIM_CL_001.vue'
import MIM_CL_002 from '@/views/im/MIM_CL_002.vue'
import MIM_CL_003 from '@/views/im/MIM_CL_003.vue'
import MIM_CL_004 from '@/views/im/MIM_CL_004.vue'
import MIM_CL_005 from '@/views/im/MIM_CL_005.vue'
import MIM_CL_006 from '@/views/im/MIM_CL_006.vue'
const goodRouter = [
 

    /* 화면명 : 상품 분류체계 등록  : MIM_CL_001  */
    {
        path: "/im/MIM_CL_001", 
        name : 'MIM_CL_001',
        components: {
            default : MIM_CL_001,
            sideMenu : ImSideMenu
        },
        meta :{
            title: '상품 분류체계 등록',
            IADepth: ['상품', '상품 분류기준 관리', '상품 분류체계 등록']
        }
    },

    /* 화면명 : 상품 분류체계 등록  : MIM_CL_003  */
    {
        path: "/im/MIM_CL_003", 
        name : 'MIM_CL_003',
        components: {
            default : MIM_CL_003,
            sideMenu : ImSideMenu
        },
        meta :{
            title: '상품 분류체계 조회',
            IADepth: ['상품', '상품 분류기준 관리', '상품 분류체계 조회']
        }
    },


    /* 화면명 : 상품 분류체계 조회/수정  : MIM_CL_002  */
    {
        path: "/im/MIM_CL_002", 
        name : 'MIM_CL_002',
        components: {
            default : MIM_CL_002,
            sideMenu : ImSideMenu
        },
        meta :{
            title: '상품 분류체계 이력 조회',
            IADepth: ['상품', '상품 분류기준 관리', '상품 분류체계 이력 조회']
        }
    },
    {
        path: "/im/MIM_CL_004", 
        name : 'test',
        components: {
            default : MIM_CL_004,
            sideMenu : ImSideMenu
        },
        meta :{
            title: '상품 분류체계 맵핑 화면',
            IADepth: ['상품', '상품 분류기준 관리', '상품 분류체계 맵핑 화면']
        }
    },
    {
        path: "/im/MIM_CL_005",
        name : 'MIM_CL_005',
        components: {
            default : MIM_CL_005,
            sideMenu : ImSideMenu
        },
        meta :{
            title: '상품버전 회계연도매핑',
            IADepth: ['상품', '상품 분류기준 관리', '상품버전 회계연도매핑']
        }
    },
    {
        path: "/im/MIM_CL_006",
        name : 'MIM_CL_006',
        components: {
            default : MIM_CL_006,
            sideMenu : ImSideMenu
        },
        meta :{
            title: '영업기회 상품정보 일괄수정',
            IADepth: ['상품', '상품 분류기준 관리', '영업기회 상품정보 일괄수정']
        }
    }
]
export {goodRouter}